module.exports = __webpack_public_path__ + "media/images/icon_company_badge4-d4842fd0f99ea39abd60c85dcdb8ede4.svg";